import React, { useContext, useEffect, useRef, useState } from "react";
import { QueryService } from "../../../../services/QueryService";
import { EventPreview } from "../../../../types/EventPreview";
import { AdminService } from "../../../../services/AdminService";
import { observe } from "mobx";
import { observer } from "mobx-react-lite";
import { storeContext } from "../../../../store/root-store";
import { ListOfDates } from "../ListOfDates";
import { MySingleEvenComp } from "../../singeEvent/SingleEventPage";
import sanitize from "sanitize-html";
import { getApiBaseUrl } from "../../../../env";
import { FreeBadget } from "../../../common/FreeBadget";
import { settingsGl } from "../../../../store/Settings";
import { LikeButton } from "./LikeButton";

function replaceNewlinesWithBr(inputString: string) {
  return inputString.replace(/\n/g, "<br>");
}

interface IEvent {
  key?: any;
  event: EventPreview;
  className: string;
  onClick: (id: number) => any;
}
const getImgPath = (imgPaths: string) => {
  const paths = imgPaths.split(";");
  return paths[0];
};

enum eventDescState {
  body = "body",
  short_text = "short_text",
}
enum eventTabs {
  adminTab = "adminTab",
  userTab = "userTab",
}

export const EventComp = observer(({ event, className, onClick }: IEvent) => {
  {
    const [currentTab, setCurrentTab] = useState<eventTabs>(eventTabs.userTab);
    const { tagsGl, eventsStore } = useContext(storeContext);
    const [currentDescState, setDescState] = useState<eventDescState>(
      eventDescState.short_text
    );
    const imgRef = useRef<HTMLImageElement>(null);
    const [imgContainerHeight, setImgContainerHeight] = useState(0);

    const changeCurrentDescState = () => {
      if (currentDescState === eventDescState.body) {
        setDescState(eventDescState.short_text);
      } else {
        setDescState(eventDescState.body);
      }
    };

    const onImgLoad = () => {
      setImgContainerHeight(imgRef?.current?.offsetHeight ?? 0);
    };

    const onLike = async (eventId: number) => {
      const res = await eventsStore.likeEvent(eventId);
      eventsStore.listOfPreviewEvents.forEach((el) => {
        if (el.id == eventId) {
          el.has_like = !el.has_like;
        }
      });
    };

    // useEffect(() => {
    //   console.log("complete" + imgRef?.current?.complete);
    //   setImgContainerHeight(imgRef?.current?.offsetHeight ?? 0);
    // }, [imgRef?.current?.complete]);

    return (
      <div className={className}>
        {AdminService.getService().isAdmin() && (
          <div className="d-flex justify-content-center mb-2">
            <div
              className="me-2"
              onClick={() => {
                setCurrentTab(eventTabs.adminTab);
              }}
            >
              Админ
            </div>
            <div
              onClick={() => {
                setCurrentTab(eventTabs.userTab);
              }}
            >
              Обычный
            </div>
          </div>
        )}
        {currentTab === eventTabs.userTab && (
          <div className="card">
            <div className="card-body">
              <div className="img-with-text">
                <div
                  className=""
                  style={{
                    margin: "auto",
                    // height: Math.floor(window.innerHeight * 0.367) + "px",
                    // width: Math.floor(window.innerWidth * 0.72) + "px",
                    // width: 50 + "%",
                    maxWidth: 100 + "%",
                    minHeight: imgContainerHeight + 10 + "px",
                    // maxHeight: 500 + "px",
                  }}
                >
                  {event.img_path && (
                    <img
                      // className={'leftfoto'}
                      id="main_event_img"
                      style={{
                        height: "auto",
                        float: "left",
                        width: 50 + "%",
                        marginRight: "1rem",
                      }}
                      onLoad={onImgLoad}
                      ref={imgRef}
                      // width={50 + "%"}
                      // height={100 + "%"}
                      src={getApiBaseUrl() + "/" + getImgPath(event.img_path)}
                      className="card-img-top"
                      alt="..."
                    />
                  )}
                  {
                    <p
                      className=""
                      style={
                        {
                          // height: 25 + "vh",
                          // overflow: "hidden",
                          // wordBreak: "break-all",
                        }
                      }
                    >
                      {event.title && (
                        <>
                          <span style={{ fontWeight: "bold" }}>
                            {event.title}
                          </span>
                          <br />
                        </>
                      )}

                      {currentDescState === eventDescState.short_text &&
                      event.short_text ? (
                        event.short_text
                      ) : (
                        <>
                          <p
                            dangerouslySetInnerHTML={{
                              __html: sanitize(
                                replaceNewlinesWithBr(event.body),
                                {
                                  allowedTags: ["br"],
                                }
                              ),
                            }}
                            // style={{ whiteSpace: "pre-line" }}
                          ></p>
                        </>
                      )}
                    </p>
                  }
                </div>
              </div>

              <div
                className="d-flex justify-content-between mt-1 mb-1"
                style={{ flexWrap: "wrap-reverse" }}
              >
                <div>
                  <button
                    className="btn"
                    style={{
                      color: "white",
                      background: "#6b1df7",
                      fontSize: 0.8 + "rem",
                      borderRadius: 10 + "px",
                    }}
                    onClick={() => {
                      window.open(
                        `https://t.me/${event.source_id
                          ?.split("_")
                          .filter((el, index, ar) => {
                            return index !== ar.length - 1;
                          })
                          .join("_")}/${event?.post_id}`
                      );
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-link"
                      viewBox="0 0 16 16"
                    >
                      <path d="M6.354 5.5H4a3 3 0 0 0 0 6h3a3 3 0 0 0 2.83-4H9q-.13 0-.25.031A2 2 0 0 1 7 10.5H4a2 2 0 1 1 0-4h1.535c.218-.376.495-.714.82-1z" />
                      <path d="M9 5.5a3 3 0 0 0-2.83 4h1.098A2 2 0 0 1 9 6.5h3a2 2 0 1 1 0 4h-1.535a4 4 0 0 1-.82 1H12a3 3 0 1 0 0-6z" />
                    </svg>
                    &nbsp; Открыть в источнике
                  </button>
                </div>
                {event.short_text && (
                  <>
                    {currentDescState == eventDescState.short_text && (
                      <div
                        className="text-button text-button-show-body"
                        onClick={changeCurrentDescState}
                        // style={{fontSize:0.7 +'rem'}}
                      >
                        Полный текст
                      </div>
                    )}
                    {currentDescState == eventDescState.body && (
                      <div
                        className="text-button text-button-show-short"
                        onClick={changeCurrentDescState}
                      >
                        Короткий текст
                      </div>
                    )}
                  </>
                )}
              </div>
              <hr />
              <div className="d-flex justify-content-between">
                <div style={{ maxWidth: 70 + "%", display: "flex" }}>
                  <LikeButton
                    className="me-2"
                    eventId={event.id}
                    onClick={async () => {
                      onLike(event.id);
                    }}
                    onLike={() => {
                      return new Promise((res, rej) => {});
                    }}
                    selected={event.has_like}
                  ></LikeButton>
                  <ListOfDates
                    key={event.id}
                    list_of_dates={event.list_of_dates}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                  }}
                >
                  {event.is_free == true && (
                    <FreeBadget
                      selected={settingsGl.showFreeEvents}
                    ></FreeBadget>
                  )}
                  {/* <div className="full-list-of-tags-item full-list-of-tags-item-selected">
                    <div
                      className="full-list-of-tags-item-text"
                      style={{ fontSize: 0.8 + "rem" }}
                    >
                      {
                        tagsGl.listOfTags.filter(
                          (tag) => tag.id == event.tag_id
                        )[0]?.name
                      }
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        )}
        {currentTab == eventTabs.adminTab && (
          <MySingleEvenComp
            key={event.id}
            eventId={event.id}
          ></MySingleEvenComp>
        )}
      </div>
    );
  }
});
